export { default as FindIcon } from "./find-icon.vue";
export * from "./IFindIcon";